export default __webpack_public_path__ + "static/media/authorizedIconEmpty.2f86bc44.svg";